import { useAppSelector } from '../../../../../hooks/hooks';
import useContext from '../../../../../hooks/useContext';
import { DataGridIdentifier } from './context';
import RowWrapper from './RowWrapper';

const Body = () => {
  const { gridId: id } = useContext(DataGridIdentifier);
  const rows = useAppSelector((global) => global.dataGridSlice[id].rows);
  return (
    <tbody className="grid__body">
      {rows.map((rowId, rowIndex) => (
        <RowWrapper key={rowId} rowIndex={rowIndex} />
      ))}
    </tbody>
  );
};
export default Body;
